<template>
  <div class="Invite">
    <div>
    <label for="">身份证号：</label>
    <my_input :inputStyle="style" v-model="idcard"></my_input>
    </div>
    <div>
    <label for="">学校/机构：</label>
    <my_input :inputStyle="style" v-model="value"></my_input>
    </div>
    <div>
    <label for="">指导老师：</label>
    <my_input :inputStyle="style" v-model="teacher"></my_input>
    </div>
  </div>
</template>

<script>
 import MyInput from '@/components/Input.vue'
 export default {
   name: '',
   data () {
     return {
       value: '',
       teacher: '',
       idcard: ''
     }
   },
   watch: {
     idcard (v) {
       this.update('updateEnrollIdCard', v)
     },
     value (v) {
       this.update('updateEnrollOrg', v)
     },
     teacher (v) {
       this.update('updateEnrollTeacher', v)
     }
   },
   methods: {
     update(key, v) {
       this.$store.commit(key,  v);
     }
   },
   computed: {
     style() {
       return {
         background: 'transparent',
         height: '1.8em',
         color: 'white',
         width: '9.6vw',
         'border-bottom': '1px solid #F8E900'
       }
     }
   },
   components: {
     my_input: MyInput
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Invite{
   width: 62.5vw;
   height: 4.375vw;
   background: linear-gradient(15deg, #4345f9, #6160ff);
   box-sizing: border-box;
   padding-left: 3.6vw;
   padding-right: 3.6vw;
   color: white;
   font-weight: 500;
   border-radius: 2px;
   display: flex;
   justify-content: space-between;
   align-items: center;
 }
  .Invite>div{
    display: flex;
  }
</style>
